import Splide from '@splidejs/splide';

(function() {
	'use strict';

	function ready(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
			return;
		}

		callback();
	}

	function each(selector, callback, root) {
		Array.prototype.forEach.call((root || document).querySelectorAll(selector), callback);
	}

	function closest(element, selector) {
		return element && element.closest ? element.closest(selector) : null;
	}

	function toSplideBreakpoints(responsive) {
		var breakpoints = {};

		if (!Array.isArray(responsive)) {
			return breakpoints;
		}

		responsive.forEach(function(item) {
			if (!item.breakpoint || !item.settings) {
				return;
			}

			breakpoints[item.breakpoint] = Object.keys(item.settings).reduce(function(settings, key) {
				if (key === 'slidesToShow') {
					settings.perPage = item.settings[key];
				} else if (key === 'slidesToScroll') {
					settings.perMove = item.settings[key];
				} else {
					settings[key] = item.settings[key];
				}

				return settings;
			}, {});
		});

		return breakpoints;
	}

	function prepareSplideMarkup(element) {
		if (element.classList.contains('splide') && element.querySelector(':scope > .splide__track')) {
			return;
		}

		var slides = Array.prototype.slice.call(element.children);
		var track = document.createElement('div');
		var list = document.createElement('div');

		element.classList.add('splide');
		element.classList.remove('row');
		track.className = 'splide__track';
		list.className = 'splide__list';

		slides.forEach(function(slide) {
			slide.classList.add('splide__slide');
			list.appendChild(slide);
		});

		track.appendChild(list);
		element.appendChild(track);
	}

	function normalizeSplideOptions(options) {
		var settings = Object.assign({
			type: 'loop',
			perPage: 1,
			perMove: 1,
			pagination: false,
			arrows: false,
			autoplay: false,
			interval: 3000,
			pauseOnHover: true,
			pauseOnFocus: true,
			rewind: false,
			gap: '1.5rem',
			breakpoints: {}
		}, options || {});

		if (settings.slidesToShow) {
			settings.perPage = settings.slidesToShow;
			delete settings.slidesToShow;
		}

		if (settings.slidesToScroll) {
			settings.perMove = settings.slidesToScroll;
			delete settings.slidesToScroll;
		}

		if (typeof settings.dots !== 'undefined') {
			settings.pagination = settings.dots;
			delete settings.dots;
		}

		if (settings.autoplaySpeed) {
			settings.interval = settings.autoplaySpeed;
			delete settings.autoplaySpeed;
		}

		if (settings.fade) {
			settings.type = 'fade';
			settings.rewind = true;
			settings.perPage = 1;
			delete settings.fade;
		}

		if (settings.infinite === false && settings.type !== 'fade') {
			settings.type = 'slide';
			settings.rewind = false;
		}

		delete settings.infinite;

		if (settings.responsive) {
			settings.breakpoints = Object.assign({}, settings.breakpoints, toSplideBreakpoints(settings.responsive));
			delete settings.responsive;
		}

		return settings;
	}

	function initSplideCarousel(selectorOrElement, options) {
		var elements = typeof selectorOrElement === 'string'
			? document.querySelectorAll(selectorOrElement)
			: [selectorOrElement];

		Array.prototype.forEach.call(elements, function(element) {
			if (!element || element.dataset.orthosSplide === 'ready') {
				return;
			}

			prepareSplideMarkup(element);

			var splide = new Splide(element, normalizeSplideOptions(options));

			splide.on('move', function(newIndex, oldIndex) {
				element.dispatchEvent(new CustomEvent('orthosSplideMove', {
					detail: {
						currentSlide: oldIndex,
						nextSlide: newIndex,
						splide: splide
					}
				}));
			});

			splide.on('moved', function(newIndex, oldIndex) {
				element.dispatchEvent(new CustomEvent('orthosSplideMoved', {
					detail: {
						currentSlide: newIndex,
						previousSlide: oldIndex,
						splide: splide
					}
				}));
			});

			splide.mount();
			element.dataset.orthosSplide = 'ready';
			element.orthosSplide = splide;
		});
	}

	window.OrthosTheme = window.OrthosTheme || {};
	window.OrthosTheme.initSplideCarousel = initSplideCarousel;

	var app = {
		windowLoaded: function () {},
		windowResized: function () {
			this.getViewport();
		},
		windowScrolled: function () {
			// Header scroll state disabled.
		},
		handleSliders: function() {
			initSplideCarousel('.slider-hero', {
				arrows: false,
				dots: true,
				autoplay: true,
				pauseOnFocus: false,
				pauseOnHover: false,
				fade: true
			});
			initSplideCarousel('.slider-items', {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false
			});
			initSplideCarousel('.slider-logos', {
				slidesToShow: 5,
				slidesToScroll: 1,
				infinite: true,
				dots: false,
				responsive: [
					{
						breakpoint: 960,
						settings: {
							slidesToShow: 2
						}
					}
				]
			});

			each('.slider-hero', function(slider) {
				slider.addEventListener('orthosSplideMove', function() {
					each('.widget-top .inner, .widget-bottom .inner', function(item) {
						item.classList.remove('active');
					});

					var title = document.getElementById('current-slide-title');
					if (title) {
						title.textContent = '';
						title.style.opacity = '0';
					}
				});

				slider.addEventListener('orthosSplideMoved', function(event) {
					var activeSlide = slider.querySelector('.splide__slide.is-active');
					var activeTitle = activeSlide ? activeSlide.querySelector('.slide-title') : null;
					var currentTitle = activeTitle ? activeTitle.textContent : '';
					var currentSlide = event.detail.currentSlide;
					var title = document.getElementById('current-slide-title');

					each('.widget-top .inner.slide' + currentSlide + ', .widget-bottom .inner.slide' + currentSlide, function(item) {
						item.classList.add('active');
					});

					if (title) {
						title.textContent = currentTitle;
						title.style.opacity = '1';
					}
				});
			});

			each('.hero-slider-prev', function(button) {
				button.addEventListener('click', function() {
					var slider = document.querySelector('.slider-hero');
					if (slider && slider.orthosSplide) {
						slider.orthosSplide.go('<');
					}
				});
			});

			each('.hero-slider-next', function(button) {
				button.addEventListener('click', function() {
					var slider = document.querySelector('.slider-hero');
					if (slider && slider.orthosSplide) {
						slider.orthosSplide.go('>');
					}
				});
			});
		},
		recognisePage: function() {
			var bodyType = document.body ? document.body.getAttribute('data-page') : null;
			this.typePage = bodyType;
		},
		mobileSpecific: function() {
			var mobileNav = document.querySelector('.mobile-nav');
			if (mobileNav && mobileNav.parentNode !== document.body) {
				document.body.appendChild(mobileNav);
			}
		},
		inputs: function() {
			// Native selects are used instead of Select2.
		},
		initGalleryLightbox: function() {
			if (!document.querySelector('section.gallery a.img[data-lightbox]')) {
				return;
			}

			var lightbox = document.getElementById('gallery-lightbox');
			if (!lightbox) {
				lightbox = document.createElement('div');
				lightbox.id = 'gallery-lightbox';
				lightbox.setAttribute('aria-hidden', 'true');
				lightbox.style.cssText = 'display:none;position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.92);align-items:center;justify-content:center;padding:24px;';
				lightbox.innerHTML =
					'<button type="button" class="gallery-lightbox-close" aria-label="Zamknij" style="position:absolute;top:16px;right:16px;border:0;background:transparent;color:#fff;font-size:44px;line-height:1;cursor:pointer;">&times;</button>' +
					'<button type="button" class="gallery-lightbox-prev" aria-label="Poprzednie" style="position:absolute;left:16px;top:50%;transform:translateY(-50%);border:0;background:transparent;color:#fff;font-size:44px;line-height:1;cursor:pointer;display:none;">&#8249;</button>' +
					'<img class="gallery-lightbox-image" alt="" style="display:block;max-width:min(1200px,100%);max-height:90vh;width:auto;height:auto;box-shadow:0 20px 60px rgba(0,0,0,0.45);">' +
					'<button type="button" class="gallery-lightbox-next" aria-label="Następne" style="position:absolute;right:16px;top:50%;transform:translateY(-50%);border:0;background:transparent;color:#fff;font-size:44px;line-height:1;cursor:pointer;display:none;">&#8250;</button>';
				document.body.appendChild(lightbox);
			}

			var image = lightbox.querySelector('.gallery-lightbox-image');
			var prevButton = lightbox.querySelector('.gallery-lightbox-prev');
			var nextButton = lightbox.querySelector('.gallery-lightbox-next');
			var items = [];
			var currentIndex = 0;

			function renderLightbox() {
				var item = items[currentIndex];
				if (!item) {
					return;
				}

				image.setAttribute('src', item.href);
				prevButton.style.display = items.length > 1 ? 'block' : 'none';
				nextButton.style.display = items.length > 1 ? 'block' : 'none';
			}

			function closeLightbox() {
				lightbox.style.display = 'none';
				lightbox.setAttribute('aria-hidden', 'true');
				document.body.style.overflow = '';
			}

			function openLightbox(trigger) {
				var groupId = trigger.getAttribute('data-lightbox');
				var group = Array.prototype.slice.call(document.querySelectorAll('section.gallery a.img[data-lightbox="' + groupId + '"]'));
				items = group.map(function(item) {
					return {
						href: item.getAttribute('href')
					};
				});
				currentIndex = group.indexOf(trigger);
				renderLightbox();
				lightbox.style.display = 'flex';
				lightbox.setAttribute('aria-hidden', 'false');
				document.body.style.overflow = 'hidden';
			}

			document.body.addEventListener('click', function(event) {
				var trigger = closest(event.target, 'section.gallery a.img[data-lightbox]');
				if (!trigger) {
					return;
				}

				event.preventDefault();
				openLightbox(trigger);
			});

			lightbox.addEventListener('click', function(event) {
				if (event.target === lightbox) {
					closeLightbox();
				}
			});

			lightbox.querySelector('.gallery-lightbox-close').addEventListener('click', closeLightbox);
			prevButton.addEventListener('click', function() {
				currentIndex = (currentIndex - 1 + items.length) % items.length;
				renderLightbox();
			});
			nextButton.addEventListener('click', function() {
				currentIndex = (currentIndex + 1) % items.length;
				renderLightbox();
			});

			document.addEventListener('keydown', function(event) {
				if (lightbox.getAttribute('aria-hidden') !== 'false') {
					return;
				}

				if (event.key === 'Escape') {
					closeLightbox();
				}

				if (event.key === 'ArrowLeft' && items.length > 1) {
					currentIndex = (currentIndex - 1 + items.length) % items.length;
					renderLightbox();
				}

				if (event.key === 'ArrowRight' && items.length > 1) {
					currentIndex = (currentIndex + 1) % items.length;
					renderLightbox();
				}
			});
		},
		handleWaypoints: function() {
			if (!('IntersectionObserver' in window)) {
				each('section', function(section) {
					section.classList.add('shown');
				});
				return;
			}

			var observer = new IntersectionObserver(function(entries) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add('shown');
						observer.unobserve(entry.target);
					}
				});
			}, { rootMargin: '0px 0px -25% 0px' });

			each('section', function(section) {
				observer.observe(section);
			});
		},
		events: function () {
			var _main = this;

			each('a[href="#"]', function(link) {
				link.addEventListener('click', function(event) {
					event.preventDefault();
				});
			});

			each('.js-site-header-toggle', function(button) {
				button.addEventListener('click', function() {
					var header = document.querySelector('.site-header');
					if (!header) {
						return;
					}

					var isOpen = !header.classList.contains('is-mobile-open');
					header.classList.toggle('is-mobile-open', isOpen);
					each('.js-site-header-toggle', function(toggle) {
						toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
					}, header);
					each('.site-header__mobile-panel', function(panel) {
						panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
					}, header);
					document.body.classList.toggle('has-mobile-nav', isOpen);
				});
			});

			each('.site-header__mobile-panel', function(panel) {
				panel.addEventListener('click', function(event) {
					if (event.target !== panel) {
						return;
					}

					var header = document.querySelector('.site-header');
					if (!header) {
						return;
					}

					header.classList.remove('is-mobile-open');
					each('.js-site-header-toggle', function(toggle) {
						toggle.setAttribute('aria-expanded', 'false');
					}, header);
					each('.site-header__mobile-panel', function(item) {
						item.setAttribute('aria-hidden', 'true');
					}, header);
					document.body.classList.remove('has-mobile-nav');
				});
			});

			each('.site-header__mobile-menu .menu-item-has-children > a', function(link) {
				link.addEventListener('click', function(event) {
					if (window.innerWidth <= _main.breakpointTablet) {
						event.preventDefault();
						link.parentElement.classList.toggle('is-open');
					}
				});
			});

			document.addEventListener('click', function(event) {
				var navLink = closest(event.target, 'nav.show a');
				if (navLink) {
					var target = document.querySelector(navLink.getAttribute('href'));
					event.preventDefault();
					var hamburger = document.querySelector('.hamburger.menu');
					if (hamburger) {
						hamburger.click();
					}
					if (target) {
						target.scrollIntoView({ behavior: 'smooth' });
					}
				}

				var galleryImage = closest(event.target, '.slider-gallery .splide__slide.is-active img');
				if (galleryImage) {
					var zoom = document.querySelector('.gallery-zoom');
					if (zoom) {
						zoom.insertAdjacentHTML('beforeend', '<img src="' + galleryImage.getAttribute('src') + '" alt="">');
						zoom.classList.add('show');
					}
				}
			});

			each('.gallery-zoom .close', function(button) {
				button.addEventListener('click', function() {
					var zoom = document.querySelector('.gallery-zoom');
					if (!zoom) {
						return;
					}

					zoom.classList.remove('show');
					each('img', function(image) {
						image.remove();
					}, zoom);
				});
			});

			each('.hamburger', function(button) {
				button.addEventListener('click', function() {
					var mainMenu = document.querySelector('.main-menu');
					if (mainMenu) {
						mainMenu.classList.toggle('show');
					}

					_main.hasNav = !_main.hasNav;
					button.classList.toggle('active');
					each('nav', function(nav) {
						nav.classList.toggle('show');
					});

					var mobileNav = document.querySelector('.mobile-nav');
					if (mobileNav) {
						mobileNav.classList.toggle('active');
					}
					document.body.classList.toggle('has-mobile-nav');
					var header = document.querySelector('header');
					if (header) {
						header.classList.toggle('has-mobile-nav');
					}
				});
			});

			each('.scroll-top', function(button) {
				button.addEventListener('click', function() {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				});
			});

			each('.hero-scroll-to-content', function(link) {
				link.addEventListener('click', function(event) {
					event.preventDefault();

					var heroSection = closest(link, '.hero-block, .page-hero, section.hero');
					var target = null;

					if (heroSection) {
						target = heroSection.nextElementSibling;

						while (target && (target.tagName === 'SCRIPT' || target.tagName === 'STYLE')) {
							target = target.nextElementSibling;
						}
					}

					if (!target) {
						target = document.getElementById('content');
					}

					if (!target) {
						return;
					}

					var header = document.getElementById('site-header') || document.querySelector('.site-header');
					var headerOffset = header ? header.offsetHeight : 0;
					var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

					window.scrollTo({
						top: Math.max(top, 0),
						behavior: 'smooth',
					});
				});
			});

			each('.nav-trigger', function(button) {
				button.addEventListener('click', function() {
					document.body.classList.toggle('has-mobile-nav');
					button.classList.toggle('active');
					var mobileNav = document.querySelector('.mobile-nav');
					if (mobileNav) {
						mobileNav.classList.toggle('active');
					}
				});
			});

			each('div[itemprop="mainEntity"] h2', function(title) {
				title.addEventListener('click', function() {
					var answer = title.nextElementSibling;
					title.classList.toggle('active');
					if (answer && answer.matches('div[itemprop="acceptedAnswer"]')) {
						answer.style.display = answer.style.display === 'none' || !answer.style.display ? 'block' : 'none';
					}
				});
			});
		},
		getViewport: function () {
			var width = window.innerWidth;
			if (width <= this.breakpointMobile) {
				this.viewport = 'mobile';
				this.mobileSpecific();
			} else if (width > this.breakpointMobile && width <= this.breakpointTablet) {
				this.viewport = 'tablet';
			} else {
				this.viewport = 'desktop';
			}
		},
		init: function () {
			this.inputs();
			this.getViewport();
			this.initGalleryLightbox();
			this.events();
			this.handleSliders();
			this.recognisePage();
			// this.handleWaypoints();
		},
		typePage: null,
		viewport: null,
		hasNav: false,
		breakpointMobile: 720,
		breakpointTablet: 1024
	};

	ready(function () {
		app.init();
	});

	window.addEventListener('load', function () {
		app.windowLoaded();
	});

	window.addEventListener('resize', function () {
		app.windowResized();
	});

	document.addEventListener('scroll', function () {
		app.windowScrolled();
	});
}());